<template>
  <div>
    <div class="poup" v-show="isShow">
      <div class="flex-box">
        <img :src="pic" alt>
        <p>认证通过之后，才可以加入下单，</p>
        <p>是否去认证资料？</p>
        <button @click="poupIdent=false;isShow=false;goPath()" class="sure">确定</button>
        <button @click="poupIdent=false;isShow=false">取消</button>
      </div>
      <div class="iconfont icon-x" @click="poupIdent=false;isShow=false"></div>
    </div>
    <div class="poup-box" v-show="poupIdent" @click="poupIdent=false;isShow=false"></div>
  </div>
</template>

<script>
import $http from "@/api/api.js";
export default {
  data() {
    return {
      isShow: "", //是否显示弹窗
      pic: require("@/assets/images/common/idPoup.png"),
      poupIdent: "" //去认证弹窗
    };
  },
  created() {
    this.bus.$on("idPoup", data => {
        //console.log(data);
      this.isShow = data;
      this.poupIdent = data;
    });
  },
  methods: {
    goPath() {
      $http.GetMemberStatus().then(res => {
        let data = res.data;
        switch (true) {
          case (data == 0):
            this.$router.push("/login");
            break;
          case (data == 2):
            this.bus.$emit('tips',{show:true,title: "审核通过才能加入购物车"})
            break;
          case (data ==  3):
            this.$router.push("/companyInfo");
            break;
          default:
            break;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@bRadius: 0.28rem;
@higColor: #ff4141;
@dftColor: #fff;
@bSize: 0.28rem;
@mSize: 0.26rem;
@sSize: 0.24rem;
.poup {
  width: 5.5rem;
  height: 5.7rem;
  background: @dftColor;
  border-radius: @bRadius;
  margin: 0 auto;
  font-size: @bSize;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -2.85rem;
  margin-left: -2.75rem;
  z-index: 12;
}
.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  line-height: 0.38rem;
  color: #999999;
  img {
    width: 80%;
    margin-bottom: 0.35rem;
  }
}
button {
  width: 3rem;
  height: 0.55rem;
  text-align: center;
  line-height: 0.55rem;
  border-radius: @bRadius - 0.05;
  border: 0;
  margin: 0.2rem 0 0.1rem;
  background: none;
  &.sure {
    background: #2b84ff;
    color: #fff;
  }
}
.poup-box {
  position: fixed;
  width: 7.5rem;
  height: 100%;
  top: 0;
  z-index: 11;
  background: rgba(0, 0, 0, 0.47);
}
.icon-x {
  color: @dftColor;
  text-align: center;
  margin-top: 0.46rem;
  font-size: 0.68rem;
}
</style>



// WEBPACK FOOTER //
// src/components/idPoup.vue